import styled from 'styled-components'
import { media } from 'styles/media'

import Container from 'components/layout/Container'

export const SectionContainer = styled(Container)`
  margin-top: 32px;
  margin-bottom: 32px;
  &:last-of-type {
    margin-bottom: 160px;
  }
  ${media.md`
    margin: 80px auto;
  `}
`

export const PageHeader = styled.h4`
  font-size: 30px;
  font-weight: 400;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  line-height: 1.3;
  margin-bottom: 8px;
`

export const SectionHeader = styled.h3`
  font-size: 24px;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-weight: 300;
  line-height: 1.4;
  margin-bottom: 24px;
  ${media.md`
    font-size: 40px;
    font-weight: 400;
    line-height: 1.3;
    margin-bottom: 16px;
    `}
`

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  ${media.md`
    flex-direction: row;
  `}
`

export const BaseCard = styled.div`
  display: flex;
  justify-content: space-between;
  border: solid;
  border-width: 1px;
  border-radius: 8px;
  width: 100%;
  padding: 16px;
  margin-bottom: 16px;
  &:not(:last-child) {
    margin-right: 0;
    ${media.md`
      margin-right: 32px;
    `}
  }
  h4 {
    font-size: 20px;
    font-weight: 400;
    ${media.md`
      font-size: 24px;
      font-weight: 300;
  `}
  }
  h4,
  svg {
    color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  }
`
